export default __webpack_public_path__ + "static/implied-motion-light-45a2b80161c64d2cfbe82ee03a61e7fbc76bd79926b0faec78e44c1dc036d4cf.mp4";